var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.6667H6.13317C5.38643 14.6667 5.01307 14.6667 4.72785 14.812C4.47697 14.9398 4.27299 15.1438 4.14516 15.3947C3.99984 15.6799 3.99984 16.0533 3.99984 16.8V28M21.9998 14.6667H25.8665C26.6132 14.6667 26.9866 14.6667 27.2718 14.812C27.5227 14.9398 27.7267 15.1438 27.8545 15.3947C27.9998 15.6799 27.9998 16.0533 27.9998 16.8V28M21.9998 28V8.26667C21.9998 6.77319 21.9998 6.02646 21.7092 5.45603C21.4535 4.95426 21.0456 4.54631 20.5438 4.29065C19.9734 4 19.2266 4 17.7332 4H14.2665C12.773 4 12.0263 4 11.4559 4.29065C10.9541 4.54631 10.5461 4.95426 10.2905 5.45603C9.99984 6.02646 9.99984 6.77319 9.99984 8.26667V28M29.3332 28H2.6665M14.6665 9.33333H17.3332M14.6665 14.6667H17.3332M14.6665 20H17.3332",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding07);
export default __webpack_public_path__ + "static/media/building-07.f529de1438b2eadd34755bd0b81965b0.svg";
export { ForwardRef as ReactComponent };